<template>
  <v-app>
    <router-view :key="$route.fullPath" />
    <!-- <v-main>
      <div v-if="$route.name !== 'Login'" style="min-height: 60px">
        <top-nav />
      </div>
      <v-row>
        <v-col v-if="$route.name !== 'Login'" class="side_nav" sm="2">
          <side-nav />
        </v-col>
        <v-col :class="{ 'col-sm-10': $route.name !== 'Login' }"
          ><router-view
        /></v-col>
      </v-row>
    </v-main> -->
     <snackbar-component></snackbar-component>
  </v-app>
  
</template>

<script>
import SnackbarComponent from "./components/snackbar/snackbar.vue";
// import '../src/assets/scss/styles.scss';
// import topNav from './components/header/top-nav.vue';
// import sideNav from './components/SideNav/SideNav.vue';
export default {
    components: { SnackbarComponent },

  name: 'App',
  // components: { topNav, sideNav },
};
</script>
